// Admin: promotores, ventas y cortes (fase 4). Contrato: docs/CONTRATO-API-FASE4.md.
// Token de admin (`admin-token`). Un 401 (token vencido o de otro rol) cierra la sesión de admin.
import { ApiError, NETWORK_ERROR_MESSAGE } from './staffApi';
import { query } from '../utils/query';

export class AdminSessionError extends ApiError {
  constructor(message = 'Tu sesión de administrador venció. Inicia sesión de nuevo.', opts = {}) {
    super(message, opts);
    this.name = 'AdminSessionError';
  }
}

export const adminFetch = async (path, { method = 'GET', body } = {}) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('admin-token')}` };
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  let response;
  try {
    response = await fetch(path, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new ApiError(NETWORK_ERROR_MESSAGE);
  }

  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }

  if (response.status === 401) throw new AdminSessionError(undefined, { status: 401, data });
  if (!response.ok || !data || data.success === false) {
    throw new ApiError(
      (data && data.error) || 'Ocurrió un error. Inténtalo de nuevo.',
      { status: response.status, code: data && data.code, data }
    );
  }
  return data;
};

// params: { status, kind, search, page, limit }
export const listAdminPromoters = (params) => adminFetch(`/api/admin/promoters${query(params)}`);

// commissionPercent: requerido si aún no tiene; si viene, lo cambia.
export const approvePromoter = (id, commissionPercent) =>
  adminFetch(`/api/admin/promoters/${encodeURIComponent(id)}/approve`, {
    method: 'POST',
    body: commissionPercent !== undefined ? { commissionPercent } : {},
  });

export const rejectPromoter = (id, reason) =>
  adminFetch(`/api/admin/promoters/${encodeURIComponent(id)}/reject`, {
    method: 'POST',
    body: reason ? { reason } : {},
  });

export const suspendPromoter = (id, reason) =>
  adminFetch(`/api/admin/promoters/${encodeURIComponent(id)}/suspend`, {
    method: 'POST',
    body: reason ? { reason } : {},
  });

export const setPromoterCommission = (id, commissionPercent) =>
  adminFetch(`/api/admin/promoters/${encodeURIComponent(id)}/commission`, {
    method: 'PATCH',
    body: { commissionPercent },
  });

// params: { from, to, status, source, promoterId, empresaId, page, limit }
export const listAdminPromoterSales = (params) => adminFetch(`/api/admin/promoter-sales${query(params)}`);

// params: { status, promoterId, empresaId, from, to, page, limit }
export const listAdminPromoterCuts = (params) => adminFetch(`/api/admin/promoter-cuts${query(params)}`);

export const getAdminPromoterCut = (id) =>
  adminFetch(`/api/admin/promoter-cuts/${encodeURIComponent(id)}`);

// weekStart: cualquier día de la semana a cortar; sin él, todas las semanas terminadas con algo pendiente.
export const generatePromoterCuts = (weekStart) =>
  adminFetch('/api/admin/promoter-cuts/generate', {
    method: 'POST',
    body: weekStart ? { weekStart } : {},
  });
